'use client';
import Link from 'next/link';
import type { WizardCtx } from '../types';
import { StepLayout, PrimaryBtn, SparkleIcon, ChatIcon, HeartIcon } from '../shared';

export function WelcomeStep({ ctx }: { ctx: WizardCtx }) {
  return (
    <StepLayout
      hero={<WelcomeHero />}
      eyebrow="WELCOME TO SPLACE"
      title={<>Be someone new,<br />for a few <em style={{ fontStyle: 'normal', color: 'var(--accent)' }}>minutes</em>.</>}
      sub="Anonymous chat with a twist: if you both want to, you reveal who you really are. No ads, no algorithm, no pressure."
      footer={
        <>
          <PrimaryBtn onClick={ctx.next}>Get started</PrimaryBtn>
          <span className="ob-foot-link">Already on Splace? <Link href="/login">Log in</Link></span>
        </>
      }
    >
      <div className="ob-welcome-bullets">
        <Bullet
          icon={<SparkleIcon />}
          title="Spin up an avatar"
          text="Pick a name, a photo, and how long it stays live (1–30 min). Then drop into the feed."
        />
        <Bullet
          icon={<ChatIcon />}
          title="Chat with whoever shows up"
          text="People message your avatar, you message theirs. Quick, low-stakes, and gone when the timer ends."
        />
        <Bullet
          icon={<HeartIcon />}
          title="Link if it clicks"
          text="Both tap link, both see each other's real profile. Otherwise the chat disappears with the avatar."
        />
      </div>
    </StepLayout>
  );
}

function Bullet({ icon, title, text }: { icon: React.ReactNode; title: string; text: string }) {
  return (
    <div className="ob-bullet">
      <div className="ob-bullet-icon">{icon}</div>
      <div>
        <div className="ob-bullet-title">{title}</div>
        <div className="ob-bullet-text">{text}</div>
      </div>
    </div>
  );
}

function WelcomeHero() {
  return (
    <div className="ob-hero-stack">
      <div className="ob-hero-card ob-hero-card--1 sp-ph">avatar</div>
      <div className="ob-hero-card ob-hero-card--2 sp-ph">avatar</div>
      <div className="ob-hero-card ob-hero-card--3 sp-ph">avatar</div>
      <div className="ob-hero-tag">
        <div className="ob-hero-tag-dot" />
        <span>Live avatars right now</span>
      </div>
    </div>
  );
}
